import { Provider } from 'react-redux';
import { Translator } from 'react-translator-component';
import dayjs from 'dayjs';

import store from './redux';
import AppRouter from './routers/AppRouter';

import './App.css';
import { useApp } from './useApp';

require('dayjs/locale/pt-br');
dayjs.locale('pt-br');

export default () => {
  const { antdLibLanguage, rtcLang } = useApp();

  if (!rtcLang) {
    return <></>;
  }

  return (
    <Translator>
      <Provider store={store}>
        <AppRouter antdLibLanguage={antdLibLanguage} />
      </Provider>
    </Translator>
  );
};
